import { scrollThin } from "../../../../styles/g-grid-v2/components/scrollbarSelect";

const customHeight = "16px";

const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
  }),


  control: (provided: any, state: any) => ({
    ...provided,
    minHeight: customHeight,
    height: customHeight,
    borderRadius: 10,
    borderColor: state.selectProps.error ? "red" : "#8a8a8a",
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: customHeight,
    padding: "0 11px 0 5px",
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    display: 'none'
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    paddingTop: 3,
    paddingBottom: 3,
    fontWeight: "normal",
    textAlign: "center",
    fontSize: 12,
    fontFamily: "Arial",
    overflow: "hidden",
    backgroundColor: state.isFocused ? "#1967d2" : "white",
    color: state.isFocused ? "white" : ""
  }),

  menuList: (provided: any, state: any) => ({
    ...provided,
    ...scrollThin,
    paddingTop: 0,
    paddingBottom: 0
  }),

  menu: (provided: any, state: any) => ({
    ...provided,
    marginTop: 0,
    paddingTop: 0,
    paddingBottom: 0,
    border: "0.2px solid gray",
    borderRadius: "none",
    boxShadow: "0.1em 0.1em 0.5em rgb(12 12 12 / 20%)"
  })
};

export default customStyles;
